import axios from "axios";

export const getReleaseData = async (
  abortSignal: AbortSignal,
  callback: any
) => {
  try {
    axios
      .get(`https://p360zingadmin-t4-devenvapi.azurewebsites.net/api/releases`, {
        signal: abortSignal,
      })
      .then((res) => {
        if (res.data) callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
};
